<template>
  <tg-layout>
    <el-row type="flex">
      <el-col :span="12">
        <h3>平面按鈕</h3>
        <el-row type="flex">
          <el-checkbox v-model="btn.round">圓角</el-checkbox>
          <el-checkbox v-model="btn.border">外框</el-checkbox>
          <el-checkbox v-model="btn.borderOnly" title="滑過時僅框線無填滿"
            >滑過不填滿</el-checkbox
          >
          <el-checkbox v-model="btn.icon">icon</el-checkbox>
          <el-checkbox v-model="btn.fill">填滿</el-checkbox>
          <el-checkbox v-model="btn.disabled">禁用</el-checkbox>
        </el-row>
        <el-row type="flex">
          <tg-button
            :round="btn.round"
            :border="btn.border"
            :icon="btn.icon ? 'bars' : null"
            :hoverBorderOnly="btn.borderOnly"
            :fill="btn.fill"
            :disabled="btn.disabled"
            >normal</tg-button
          >
          <template v-for="(theme, i) in themes">
            <tg-button
              :key="i"
              :theme="theme"
              :round="btn.round"
              :border="btn.border"
              :icon="btn.icon ? 'bars' : null"
              :hoverBorderOnly="btn.borderOnly"
              :fill="btn.fill"
              :disabled="btn.disabled"
              >{{ theme }}</tg-button
            >
          </template>
        </el-row>
        <h3>表單按鈕</h3>
        <el-row type="flex">
          <tg-button round :classes="['tg-btn--search']" icon="search"
            >查詢</tg-button
          >
          <tg-button round :classes="['tg-btn--confirm']">確認</tg-button>
        </el-row>
        <h3>其他按鈕</h3>
        <el-row type="flex">
          <tg-button round :classes="['tg-btn-prompt--confirm']"
            >確認</tg-button
          >
          <tg-switch-btn
            leftLabel="全部接受"
            :leftIcon="['far', 'circle']"
            rightLabel="全部拒絕"
            rightIcon="times"
          ></tg-switch-btn>
        </el-row>
      </el-col>
      <el-col :span="8">
        <h3>下拉框</h3>
        <el-row type="flex" justify="start">
          <tg-dropdown :items="dropdown">
            <template slot="icon">
              <font-awesome-icon icon="times" size="1x"></font-awesome-icon>
            </template>
          </tg-dropdown>
          <tg-dropdown :items="dropdown"></tg-dropdown>
        </el-row>
        <h3>日期選擇器</h3>
        <tg-date-search
          ref="dateSearch"
          size="small"
          showDateRangePicker
          twoMonthLimit
          isAccountDate
        ></tg-date-search>
      </el-col>
    </el-row>
    <el-row>
      <h3>卡片</h3>
      <el-row type="flex" justify="start">
        <tg-list-card-group :lists="list"> </tg-list-card-group>
      </el-row>
    </el-row>
    <el-row>
      <h3>FormTable</h3>
      <el-row>
        <tg-form-table
          :columns="formTableColumns"
          :fenceCol="2"
          :fenceRow="3"
          showSecond
          second-title="VIP等級資訊"
          :secondFenceCol="2"
          :secondFenceRow="3"
          :second-columns="formTableColumns2"
        ></tg-form-table>
      </el-row>
    </el-row>
    <el-row>
      <div
        v-loading="true"
        element-loading-text="Loading"
        element-loading-spinner="tg-icon-loading"
        element-loading-custom-class="tg-loading--wrapper"
        style="height: 650px"
      ></div>
    </el-row>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgButton from "@/components/button/TgButton";
import TgSwitchBtn from "@/components/button/TgSwitchBtn";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgListCardGroup from "@/components/card/TgListCardGroup";
import TgFormTable from "@/components/table/TgFormTable";

export default {
  components: {
    TgLayout,
    TgButton,
    TgSwitchBtn,
    TgDropdown,
    TgDateSearch,
    TgListCardGroup,
    TgFormTable,
  },
  data() {
    return {
      themes: ["primary", "info", "success", "warning", "danger"],
      btn: {
        round: false,
        border: false,
        icon: false,
        borderOnly: false,
        fill: false,
        disabled: false,
      },
      dropdown: [
        {
          value: 1,
          label: "abc",
        },
        {
          value: 2,
          label: "abc2",
        },
      ],
      list: [
        {
          label: "全部總監",
          data: [
            {
              langKey: "123",
              size: "5",
              name: "test",
              username: "qwe",
              usernickname: "asd",
              disabled: false,
            },
            {
              langKey: "123",
              size: "5",
              name: "test",
              username: "qwe",
              usernickname: "asd",
              disabled: false,
            },
            {
              langKey: "123",
              size: "5",
              name: "test",
              username: "qwe",
              usernickname: "asd",
              disabled: false,
            },
            {
              langKey: "123",
              size: "5",
              name: "test",
              username: "qwe",
              usernickname: "asd",
              disabled: false,
            },
            {
              langKey: "123",
              size: "5",
              name: "test",
              username: "qwe",
              usernickname: "asd",
              disabled: false,
            },
          ],
        },
        {},
      ],
      formTableColumns: [
        {
          name: "username",
          title: "帳號",
          label: "帳號",
          slot: "userfullname",
          nickname: "usernickname",
          langKey: "login_account",
        },
        {
          name: "password",
          title: "密碼",
          label: "密碼",
          slot: "password",
          enable: true,
          langKey: "password",
        },
        {
          name: "repassword",
          title: "密碼再確認",
          label: "密碼再確認",
          slot: "password",
          enable: true,
          langKey: "repassword",
        },
        {
          name: "usernickname",
          title: "暱稱",
          label: "暱稱",
          slot: "text_input",
          enable: true,
          langKey: "usernickname",
        },
        {
          name: "loginblocked",
          title: "登入狀態",
          label: "登入狀態",
          slot: "blocked",
          langKey: "loginblocked",
        },
        {
          name: "betblocked",
          title: "下注状态",
          label: "下注状态",
          slot: "blocked",
          langKey: "betblocked",
        },
        {
          name: "withdrawmoneyblocked",
          title: "提领状态",
          label: "提领状态",
          slot: "blocked",
          editable: false,
          langKey: "withdrawmoneyblocked",
        },
        {
          name: "activedate",
          title: "账户启用时间",
          label: "账户启用时间",
          langKey: "activedate",
        },
        {
          name: "totalquota",
          title: "总额度",
          label: "总额度",
          format: "unit:(万)",
          langKey: "totalquota",
        },
        {
          name: "quota",
          title: "可用余额",
          label: "可用余额",
          format: "unit:(万)",
          langKey: "left_quota",
        },
        {
          name: "status",
          title: "会员状态",
          label: "会员状态",
          langKey: "member_status",
        },
        {
          name: "requestTime",
          title: "首充日期",
          label: "首充日期",
          slot: "relativeTime",
          langKey: "requestTime",
        },
        {
          name: "note",
          title: "备注",
          label: "备注",
          slot: "text_input",
          enable: true,
          langKey: "note",
        },
        {
          name: "title",
          title: "VIP等级资讯",
          label: "VIP等级资讯",
          type: "title",
          langKey: "component.label.member.vip_info",
        },
        {
          name: "users_level",
          title: "会员等级",
          label: "会员等级",
          langKey: "vip_info.tg_member_level",
        },
        {
          name: "keep_keep_result_quantity",
          title: "保级差额",
          label: "保级差额",
          format: "decimal:2",
          langKey: "vip_info.keep_level_quantity",
        },
        {
          name: "up_level_quantity",
          title: "升级差额",
          label: "升级差额",
          children: [
            {
              name: "up_level_save",
              title: "累计充值差额",
              label: "累计充值差额",
              format: "decimal:2",
              langKey: "vip_info.up_level_save_quantity",
            },
            {
              name: "up_level_result_quantity",
              title: "累计实货量差額",
              label: "累计实货量差額",
              format: "decimal:2",
              langKey: "vip_info.up_level_result_quantity",
            },
            {
              name: "up_keep_result_quantity",
              title: "保级实货量差额",
              label: "保级实货量差额",
              format: "decimal:2",
              langKey: "vip_info.up_keep_result_quantity",
            },
          ],
          langKey: "vip_info.up_level_quantity",
        },
      ],
      formTableColumns2: [
        {
          name: "username",
          title: "帳號",
        },
        {
          name: "password",
          title: "密碼",
        },
        {
          name: "sss",
          title: "sss",
          children: [
            {
              name: "ss1",
              title: "ss1",
            },
            {
              name: "ss2",
              title: "ss2",
            },
            {
              name: "ss3",
              title: "ss3",
            },
          ],
        },
      ],
      loading: true,
    };
  },
};
</script>
